export type ContentType = "application/json" | "multipart/form-data"

export class Http {
  static serviceNotAvailableMessage = "Service is not available";

  static async get(url: string, data?: any): Promise<any> {
    return await this.request("GET", url, data)
  }

  static async post(url: string, data: any, contentType: ContentType = "application/json"): Promise<any> {
    return await this.request("POST", url, data, contentType);
  }
  static async patch(url: string, data: any, contentType: ContentType = "application/json"): Promise<any> {
    return await this.request("PATCH", url, data, contentType);
  }

  static async delete(url: string): Promise<any> {
    return await this.request("DELETE", url);
  }

  private static async request(
    method: "POST" | "GET" | "DELETE" | "PATCH",
    url: string,
    data: any = null,
    contentType: ContentType = "application/json",
  ) {
    const body = !!data && contentType === "application/json"
      ? JSON.stringify(data)
      : data

    const headers = contentType === "application/json"
      ? {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
      : undefined

    const result = await fetch(url, {
      method: method,
      cache: "reload",
      credentials: "same-origin",
      body: body,
      headers
    })

    if (result.status === 204) {
      return null;
    } else if (result.status >= 400) {
      let error: any = new Error(
        "Request failed: " + result.status + ": " + result.statusText
      );
      error.status = result.status;

      if (result.status == 503) {
        const data = await result.json();
        data.message && (error.message = data.message);
        throw error;
      }
      throw error;
    } else {
      return result.json();
    }
  }
}
